import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IconService {
    cache = {};
    requestCache = {};

    constructor() {

    }

    /**
     * Gets a SVG graphic, storing it into the cache.
     * @param src
     */
    getSvg(src) {
      if (this.cache[src]) {
        return Promise.resolve(this.cache[src]);
      }
      if (this.requestCache[src]) {
        return this.requestCache[src];
      }
        
      this.requestCache[src] = fetch(`/${src}`)
        .then(response => response.text())
        .then(response => {
          this.cache[src] = response.substr(38);
          return response.substr(38);
        });
      return this.requestCache[src];
    }
}